import { messageProxyFactory } from "@src/features/experienceBuilder/messageProxyFactory";
import { PREVIEW_IFRAME_ID } from "@src/features/experienceBuilder/constants";
import { AppListenerMiddleware, RootState } from "@src/store";

import { registerMessageProxyHandlers } from "./registerMessageProxyHandlers";
import { setupMissingNodesListener } from "./setupMissingNodesListener";
import { setupSendHighlightsListener } from "./setupSendHighlightsListener";
import { setupSendModeListener } from "./setupSendModeListener";
import { setupSendPreviewStateListener } from "./setupSendPreviewStateListener";
import { setupPreviewErrorListener } from "./setupPreviewErrorListener";
import { isDialogOpen } from "@src/store/slices/global";
import { clearAiChat } from "@src/store/slices/aiChat";
import { experienceBuilderAiSlice } from "@src/store/slices/experienceBuilder/ai/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const dialogOpen = isDialogOpen("experienceBuilder");

export function setupBuilderLifecycleListener(
  middleware: AppListenerMiddleware
) {
  middleware.startListening({
    predicate: (_, state: RootState, prev: RootState) =>
      dialogOpen(state) && !dialogOpen(prev),
    effect: async (_action, api) => {
      const messageProxy = messageProxyFactory.create(PREVIEW_IFRAME_ID);
      registerMessageProxyHandlers(api, messageProxy);
      const unsubscribes = [
        setupSendPreviewStateListener(middleware, messageProxy),
        setupSendModeListener(middleware, messageProxy),
        setupSendHighlightsListener(middleware, messageProxy),
        setupMissingNodesListener(middleware, messageProxy),
        setupPreviewErrorListener(middleware),
      ];

      await api.take((_, state) => !dialogOpen(state));

      api.dispatch(clearAiChat());
      api.dispatch(experienceBuilderAiSlice.actions.clear());
      api.dispatch(experienceBuilderSlice.actions.clear());

      unsubscribes.forEach((unsubscribe) => unsubscribe());
      messageProxyFactory.destroy(PREVIEW_IFRAME_ID);
    },
  });
}
